/**
 * Valor em reais digitado à mão (12/10/2026, C4 do bloco C): "39,9" vira "39,90" ao sair do campo.
 *
 * `lerValorBR` aceita o que a pessoa digita de verdade: vírgula decimal ("39,9"), milhar com ponto ("1.234,5") e, por
 * hábito do campo numérico que existia antes, ponto decimal sozinho ("39.9"). Vazio ou ilegível vira null, e quem chama
 * decide (no unitário, null é zero).
 */
export function lerValorBR(texto: string): number | null {
  const t = String(texto ?? '').trim().replace(/^R\$\s*/, '');
  if (!t) return null;
  let normal: string;
  if (t.includes(',')) normal = t.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(t)) normal = t.replace(/\./g, ''); // "1.234" é milhar, não 1,234
  else normal = t;
  if (!/^-?\d*(\.\d*)?$/.test(normal) || normal === '' || normal === '.') return null;
  const n = Number(normal);
  return Number.isFinite(n) ? n : null;
}

/** 39.9 → "39,90"; 1234.5 → "1.234,50". Sempre duas casas. */
export function formatarValorBR(n: number): string {
  return (Number(n) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
